































import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { FitIcon } from '@tencent/wphk-ui';
@Component({
  components: {
    FitIcon,
  },
})
export default class FitSearchList extends Vue {
  @Prop({ default: () => [] }) public list!: any[];
  @Prop({ default: '' }) public title!: string;
  @Prop({ default: false }) public loading!: boolean;
  @Model('change') public readonly value!: string[] | number[];
  onClick(item) {
    this.$emit('select');
    this.$emit('change', item.value, item);
  }
}
